import React, { useEffect, useState, useRef } from 'react';
import { Typography, Paper, Grid } from '@material-ui/core';
import { connect } from "react-redux";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { DialogTitle, DialogContent, DialogActions } from '../../components/Dialog/Dialog';
import { useForm, Controller } from 'react-hook-form';
import InputAdornment from '@material-ui/core/InputAdornment';
import { addNewParty, getPartyList, emptyPartyList } from "../../../store/actions/tripActionCreator";
import { editParty,addPartyOpeningBalance,editPartyOpeningBalance } from "../../../store/actions/partiesActionCreator";
import { sendError, sendSucces } from "../../../utils/utils";
import * as logger from "../../../logger";
import { trackDwebEvent } from '../../analytics';
import { getPartyLedgerData } from '../../../store/actions/homeActionCreator';
import { TextField,DatePicker } from 'mui-rff';
import { Form } from 'react-final-form';
import AddIcon from '@material-ui/icons/Add';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { TickShield } from '../../../components/icons';
import { defaultPageNo,defaultPageSize } from '../../../paginationVariables';
import AmountInput from '../../components/Inputs/AmountInput';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';
import DateFnsUtils from '@date-io/date-fns';
import { replaceCommas } from '../../../utils/utils';
const styles = makeStyles(theme => ({
  formRoot: {
    '& .MuiFormControl-root': {
      width: '100%',
      margin: '16px 0px'
    }
  },
  error: {
    color: 'red',
    marginBottom: 8
  },
  marginV2: {
    marginTop: 16
  },
  marginV3: {
    marginTop: 16,
    marginLeft:11
  },
  title: {
    color: '#9ea0a5',
    fontSize: 12
  },
  formHelperText: {
    color: '#9ea0a5',
    fontSize: 11,
    marginTop: 4,
  },
  marginV1: {
    marginTop: 6,
    width: '100%'
  },
  textV1: {
    marginTop: 6,
    width: '100%',
    "& .MuiOutlinedInput-input": {
      textTransform: 'capitalize',
    },
  },
  brV1: {
    borderRadius: 8
  },
  divFlex: {
    display: 'flex',
    alignItems: 'center',
    color: '#0033cc',
    marginTop: 20,
    letterSpacing: '0.02em',
    fontWeight: 300,
  },
  titleBullet: {
    borderRadius: "50%",
    backgroundColor: "lightgrey",
    fontSize: 8,
    color: "lightgrey",
    margin: "0px 6px",
    marginTop: -2
  },
  divAlign: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 20
  },
  addIcon: {
    marginTop: -2,
    fontSize: 15,
    cursor: 'pointer'
  },
  textV2: {
    marginLeft: 4,
    cursor: 'pointer'
  },
  disableCta: {
    padding: '9px 26px 11px 28px',
    borderRadius: 4,
    boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1)',
    backgroundColor: '#efeff2',
    fontSize: 14,
    fontWeight: 'bold',
    color: '#3e3f42',
    height: 36,
    textTransform: 'capitalize',
    letterSpacing: '0.02em'
  },
  saveCta: {
    padding: '9px 26px 11px 28px',
    borderRadius: 4,
    boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1)',
    backgroundColor: '#0033cc',
    fontSize: 14,
    fontWeight: 300,
    color: 'white',
    height: 36,
    textTransform: 'capitalize',
    letterSpacing: '0.02em',
    '&:hover': {
      backgroundColor: '#0033cc',
    }
  },
  eventIcon: {
    color: 'grey'
  }
}))

const AddEditOpeningBalanceParty = (props) => {
  let submit;
  const { children, user, 
    defaultId, defaultName, 
    defaultNumber,
    defaultOpeningBalance,
    defaultOpeningBalanceDate,
    startOpeningBalanceDate,
    parties,
    dispatchGetPartyLedgerAction, dispatchEmptyPartyList, dispatchAddNewPartyBalance, dispatchGetPartyListAction, dispatchEditPartyBalance, classes, open, onClose, onSave, ...other 
  } = props;
  const [dialogopen, setDialogOpen] = React.useState(open);
  const [partyNameValue, setPartyNameValue] = useState(defaultName ? defaultName : "");
  const [openingBalanceAmount, setOpeningBalanceAmount] = useState(defaultOpeningBalance && defaultOpeningBalance>0?defaultOpeningBalance:0);
  const [mobileNumberFlag, setMobileNumberFlag] = useState(defaultNumber ? true : false);
  const [dataFlag, setDataFlag] = useState(false);

  const inlineStyles = styles();

  const initialValues = {
    openingBalance:openingBalanceAmount,
    openingBalanceDate:defaultOpeningBalanceDate? new Date(Number(defaultOpeningBalanceDate) * 1000):parties 
    && parties.details 
    && parties.details.defaultOpeningBalanceDate?new Date(Number(parties.details.defaultOpeningBalanceDate)*1000):new Date()
  }

  const handlePartySave = (e) => {
  }
  const handleClose = (status) => {
    onClose(false);
  };
  useEffect(() => {
    trackDwebEvent('Dweb Party Create Initiated');
  }, [dialogopen]);

  const onSubmit = data => {

    const partyLedgerRequestData = {
      fleetOwnerId: user && user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : null,
      pageNo: defaultPageNo,
      pageSize: defaultPageSize,
    };
    if (defaultId) {
      var data = {
        amount:Number(replaceCommas(data.openingBalance)),
        expenseDate:Math.round(data.openingBalanceDate.setHours(0, 0, 0, 0) / 1000),
      }

      dispatchEditPartyBalance(defaultId,
        data,
        (data) => {
          if (data && data.status && data.status.code && data.status.code == 200) {
            sendSucces("Party Opening Balance Updated Successfully!")
            onClose(false);
            onSave(data.response);
          }
        },
        () => {
          logger.log("Add Party Component", "Edit Party Failed");
        }
      )
    }
    else {
      dispatchAddNewPartyBalance(
        {
          customerId: parties && parties.details && parties.details.customerId?parties.details.customerId:null,
          amount:Number(replaceCommas(data.openingBalance)),
          expenseDate:Math.round(data.openingBalanceDate.setHours(0, 0, 0, 0) / 1000),
          type:"OPENING_BALANCE"
        },
        (addResponse) => {
          if (addResponse && addResponse.status && addResponse.status.code && addResponse.status.code == 200) {
            sendSucces("Party Opening Balance Added Successfully!")
            onClose(false);
            onSave(data.response);
          }
        },
        () => {
        }
      );
    }
  };

 

  const getFormFields = (values) => {
    return [
      {
        size: 12,
        visible:true,
        field: (
          <>
            <div className={inlineStyles.marginV2}>
              <div className={inlineStyles.title}>Opening Balance</div>
              <AmountInput
                  // label="Amount"
                  placeholder="Opening Balance"
                  name="openingBalance"
                  variant="outlined"
                  size="small"
                  required={true}
                  className={inlineStyles.textV1}
                  onChange={(e) => { setOpeningBalanceAmount(e.target.value) }}
                  fieldProps={{
                      // parse: value => value && numberWithCommas(value)
                  }}
              />
            </div>
          </>
        ),
      },
      {
        size: 12,
        visible: true,
        field: (
          <>
            <div className={inlineStyles.marginV2}>
              <div className={inlineStyles.title}>Opening Balance Date</div>
              <DatePicker
                disableFuture
                name="openingBalanceDate"
                variant="inline"
                inputVariant="outlined"
                /*minDate={parties 
                  && parties.details 
                  && parties.details.defaultOpeningBalanceDate?new Date(Number(parties.details.defaultOpeningBalanceDate)*1000):startOpeningBalanceDate?new Date(Number(startOpeningBalanceDate)*1000):null}*/
                size="small"
                format="dd-MM-yyyy"
                // label="Date"
                placeholder="Opening Balance Date"
                dateFunsUtils={DateFnsUtils}
                InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={inlineStyles.eventIcon}></EventOutlinedIcon></InputAdornment> }}
                //onChange={(date) => setDateValue(date)}
                className={inlineStyles.textV1}
            />
            </div>
          </>
        ),
      },
      {
        size: 12,
        visible: false,
        field: (
          <>
            <div className={inlineStyles.divAlign}>
              <TickShield />
              <div>
                100% Safe & Secure
              </div>
              <FiberManualRecordIcon className={inlineStyles.titleBullet}></FiberManualRecordIcon>
              <div>
                256-bit Encryption
              </div>
            </div>
          </>
        )
      }
    ]
  }

  const validate = values => {

    const errors = {}

    // let partyName = values.name ? /^[A-Za-z]+$/.test(values.name.replace(/\s+/g, '')) : "";
    let number = values.mobile ? /^[5-9]{1}[0-9]{9}$/.test(values.mobile.replace("-", "")) : "";

    if (values && !values.openingBalance) {
      errors.openingBalance = "Please enter a Opening Balance Amount"
    }
    if (values && !values.openingBalanceDate) {
      errors.openingBalanceDate = "Please select a Opening Balance Date"
    }
    
    if (values && values.openingBalance && values.openingBalanceDate) {
      setDataFlag(true);
    } else {
      setDataFlag(false);
    }

    return errors;

  }

  return (
    <div>
      <Dialog fullWidth={true}
        maxWidth='xs'
        onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-party-dialog-title" open={dialogopen}
        classes={{ paperScrollPaper: inlineStyles.brV1 }}
      >
        <DialogTitle id="add-party-dialog-title" onClose={handleClose}>
          {defaultId ?
            (
              <span>Edit Opening Balance</span>
            ) : (
              <span>Add Opening Balance</span>
            )
          }
        </DialogTitle>
        <DialogContent dividers>
          <Form
            onSubmit={onSubmit}
            keepDirtyOnReinitialize
            initialValues={initialValues}
            validate={validate}
            id="myForm"
            render={({ handleSubmit, form, submitting, pristine, values }) => {
              submit = handleSubmit
              return (
                <form onSubmit={handleSubmit} noValidate id="myForm">
                  <Grid container alignItems="flex-start">
                    {getFormFields(values).map((item, idx) => item.visible ? (
                      <Grid item xs={item.size} key={idx}>
                        {item.field}
                      </Grid>
                    ) : null)}
                  </Grid>
                </form>
              )
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="contained" className='modal-close-cta' onClick={handleClose} style={{ marginRight: 16 }} >
            Close
          </Button>
          <Button className={!dataFlag ? inlineStyles.disableCta : inlineStyles.saveCta} type="submit" variant="contained"
            // onClick={() => {
            //   document.getElementById('myForm')
            //     .dispatchEvent(new Event('submit', { cancelable: true }))
            // }}
            onClick={event => {
              submit(event)
            }}
            disabled={!dataFlag}
          >
            Save changes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchAddNewPartyBalance: (request, onSuccess, onFailure) => dispatch(addPartyOpeningBalance(request, onSuccess, onFailure)),
  dispatchGetPartyListAction: (data, onSuccess, onFailure) => dispatch(getPartyList(data, onSuccess, onFailure)),
  dispatchEditPartyBalance: (id, data, onSuccess, onFailure) => dispatch(editPartyOpeningBalance(id, data, onSuccess, onFailure)),
  dispatchEmptyPartyList: () => dispatch(emptyPartyList()),
  dispatchGetPartyLedgerAction: (requestData) =>
    dispatch(
      getPartyLedgerData(
        requestData,
        () => {
          logger.log("Party Ledger", "Party Ledger Data Loading Success");
        },
        () => {
          logger.log("Party Ledger", "Party Ledger Data Loading Failure");
        }
      )
    ),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddEditOpeningBalanceParty);